"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _index = _interopRequireDefault(require("./components/table-view/index"));

var _customView = _interopRequireDefault(require("./components/custom-view"));

var _doItYourselfView = _interopRequireDefault(require("./components/do-it-yourself-view"));

var _dataGrid = _interopRequireDefault(require("../data-grid"));

var _dataGridContext = _interopRequireDefault(require("../data-grid-context"));

var DataGridBody = function DataGridBody(_ref) {
  var children = _ref.children;

  var _useContext = (0, _react.useContext)(_dataGridContext["default"]),
      setHasCustomView = _useContext.setHasCustomView,
      setHasTableView = _useContext.setHasTableView,
      setHasDoItYourselfView = _useContext.setHasDoItYourselfView;

  var checkDetailBarsOnChildren = (0, _react.useCallback)(function (child) {
    var updateChildrenState = function updateChildrenState(child) {
      if (child !== null) {
        switch (child.type) {
          case _dataGrid["default"].Body.CustomView:
            setHasCustomView(true);
            break;

          case _dataGrid["default"].Body.TableView:
            setHasTableView(true);
            break;

          case _dataGrid["default"].Body.DoItYourselfView:
            setHasDoItYourselfView(true);
            break;
        }
      }
    };

    if (child !== null) {
      updateChildrenState(child);

      if (Array.isArray(child.props.children)) {
        child.props.children.forEach(function (child) {
          return checkDetailBarsOnChildren(child);
        });
      }
    }
  }, [setHasCustomView, setHasTableView, setHasDoItYourselfView]);
  (0, _react.useEffect)(function () {
    _react["default"].Children.forEach(children, checkDetailBarsOnChildren);
  }, [checkDetailBarsOnChildren, children]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};

DataGridBody.TableView = _index["default"]; // Table view only -- AgGrid

DataGridBody.CustomView = _customView["default"]; // Custom views can be implemented like Card, Item, Photo etc.

DataGridBody.DoItYourselfView = _doItYourselfView["default"]; // View that is completely customizable by the user

DataGridBody.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};
var _default = DataGridBody;
exports["default"] = _default;